_ = require 'underscore'
{ shouldFireConfetti } = require 'app/scripts/views/card/should-fire-confetti'
confetti = require('canvas-confetti').default

module.exports.moveTo = (e, ui, listViewDest, sameList) ->
  if ui.item.parents('.js-list').length == 0
    # Sometimes Internet Explorer 10 fires this event when the card is not
    # displayed. Just treat it as a failed drag for now. - Brett, July 2013
    # I can't reproduce this, but I'm afraid to take it out. - Ian, Oct 2014
    listViewDest?.renderCards()
    return

  cards = ui.item.parents('.js-list').find('.list-card:not(.placeholder,.js-composer)')
  index = cards.index(ui.item)

  if !sameList
    if shouldFireConfetti(listViewDest.model.get('name'))
      listViewOffset = ui.item.offset()
      cardHeight = ui.item.height()
      cardWidth = ui.item.width()

      confetti({
        angle: _.random(55, 125)
        spread: _.random(50, 70)
        particleCount: _.random(40, 75)
        origin: {
          x: (listViewOffset.left + cardWidth / 2) / window.innerWidth
          y: (listViewOffset.top + cardHeight / 2) / window.innerHeight
        }
      })

    # We don't need the element that they dragged to stick around; we'll add
    # a new one when we modify the list
    ui.item.remove()

  @model.moveToList(listViewDest.model, index)

  return

module.exports.moveIn = (e, ui, listView) ->
  # moveTo always gets called because it's triggered from
  # sortStop even if it's outside the original list.
  if (listView.model.id == @model.get('idList'))
    @moveTo(e, ui, listView, true)

  return
